import React, { useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { motion, useInView } from "framer-motion";
import Navbar from "../components/Navbar";
import axios from "axios";
import { secretKey, baseURL } from "../utils/constant";
import { Container, Row, Col } from "react-bootstrap";
import Image9 from "../assets/images/home/image-3.jpg";
import { Link } from "react-router-dom";

function Western({ setPageTitle }) {
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [prices, setPrices] = useState({});

  const headers = {
    Authorization: `Bearer ${secretKey}`,
    "Content-Type": "application/x-www-form-urlencoded",
  };

  const imageRef = useRef(null);
  const productSectionRef = useRef(null);
  const imageInView = useInView(imageRef, { once: true });
  const productSectionInView = useInView(productSectionRef, { once: true });

  useEffect(() => {
    setPageTitle("Executive Elegance - Bait Al Anaqah");
    const query = "active:'true' AND metadata['western']:'western'";
    setIsLoading(true);

    axios
      .get(`${baseURL}/v1/products/search`, {
        headers,
        params: { query },
      })
      .then((response) => {
        const fetchedProducts = response.data.data;
        setProducts(fetchedProducts);
        setIsLoading(false);

        fetchedProducts.forEach((product) => {
          if (product.default_price) {
            fetchPrice(product.default_price);
          }
        });
      })
      .catch((err) => {
        console.error("Error in API Call", err);
        setIsLoading(false);
      });
  }, [setPageTitle]);

  const fetchPrice = (priceId) => {
    axios
      .get(`https://api.stripe.com/v1/prices/${priceId}`, { headers })
      .then((response) => {
        const { unit_amount, currency } = response.data;
        setPrices((prevPrices) => ({
          ...prevPrices,
          [priceId]: { amount: unit_amount / 100, currency },
        }));
      })
      .catch((err) => {
        console.error(`Error fetching price for ${priceId}`, err);
      });
  };

  const image9Variants = {
    hidden: { opacity: 0, y: 80 },
    visible: { opacity: 1, y: 0 },
  };

  const productAnimationContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3, // Staggered animations for children
      },
    },
  };

  const productAnimationVariants = {
    hidden: {
      opacity: 0,
      clipPath: "inset(0% 0% 100% 0%)", // Start fully hidden from the top
    },
    visible: {
      opacity: 1,
      clipPath: "inset(0% 0% 0% 0%)", // Reveal the full product
      transition: {
        duration: 1.5, // Control the speed of the curtain effect
      },
    },
  };

  return (
    <>
      <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image9} />
        <link rel="canonical" href="https://baitalanaqah.com/executive-elegance" />
      </Helmet>
      <Navbar />
      <Container fluid className="px-0 overflow-hidden text-center">
        <motion.img
          ref={imageRef}
          src={Image9}
          className="img-fluid "
          alt="Header"
          initial="hidden"
          animate={imageInView ? "visible" : "hidden"}
          variants={image9Variants}
          transition={{ duration: 1 }}
        />
        <Row>
          <Col lg={6} className="mx-auto text-center border-bottom py-5">
            <h4 className="fst-italic mb-5">
              "Where precision meets sophistication"
            </h4>
            <p className="mb-0 px-lg-0 px-4">
              Designed for discerning professionals, our Executive Elegance
              collection embodies the timeless artistry of couture tailoring.
              Each suit is a masterpiece of craftsmanship, tailored to
              perfection for those who demand distinction in the world of
              business. With a focus on luxurious fabrics and impeccable fit,
              this collection is a celebration of modern professionalism and
              enduring style.
            </p>
          </Col>
        </Row>
      </Container>
      <Container className="py-5">
        <h2 className="fw-lighter fw-normal text-center mb-5">
          Executive Elegance Collection
        </h2>
        <motion.div
          ref={productSectionRef}
          initial="hidden"
          animate={productSectionInView ? "visible" : "hidden"}
          variants={productAnimationContainer}
          className="row justify-content-center"
        >
          {isLoading ? (
            <Col>
              <p>Loading...</p>
            </Col>
          ) : products.length > 0 ? (
            products.map((product, index) => (
              <motion.div
                key={index}
                className="col-lg-4 text-center mb-4"
                variants={productAnimationVariants}
                transition={{ duration: 3 }}
              >
                <Link to={`/product/${product.id}`} className="text-decoration-none text-dark mb-3">
                  <div className="vhx-80 overflow-hidden mb-3">
                    <img
                      src={product.images}
                      className="img-fluid img-fade-in"
                      alt="Product"
                    />
                  </div>
                  <p className="mb-0">
                    {product.name || "Unnamed Product"}
                  </p>
                  <p className="text-uppercase">
                    {prices[product.default_price]
                      ? `${prices[product.default_price].amount} ${prices[product.default_price].currency}`
                      : ""}
                  </p>
                </Link>
              </motion.div>
            ))
          ) : (
            <Col>
              <p>No products available.</p>
            </Col>
          )}
        </motion.div>
      </Container>
    </>
  );
}

export default Western;
